export const makeIntlFormats = () => ({
  number: {
    price: {
      style: 'currency',
      currency: 'USD',
    },
  },
})
